/**
 * Subtle primary-tinted fade at the top of the sidebar. Used by both
 * AppShellSidebar (desktop) and MobileSidebarDrawer to share the same
 * brand-tint chrome without duplicating the inline gradient.
 */
export function SidebarTopFade() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          'linear-gradient(180deg, rgb(var(--color-primary) / 0.04) 0%, rgb(var(--color-primary) / 0) 60%)',
      }}
    />
  );
}
